<template>
<div class="animate-pulse bg-slate-300 rounded mr-4 inline-flex"></div>
</template>